<script setup lang="ts">
import { PropType } from 'vue'
import Product from '~/models/Product/Product'

defineProps({
    product: {
        type: Object as PropType<Product>,
        required: true,
    },
})

const emit = defineEmits(['redirectToUrl'])
</script>

<template>
    <div class="product__variants">
        <a :href="product.url" class="btn btn-outline-primary rounded-25" @click.prevent="emit('redirectToUrl', $event)">
            {{ $t('productDetail.productVariants', product.variantsCount) }}
        </a>
    </div>
</template>

<style scoped lang="scss">
.product {
    &__variants {
        text-align: center;

        .btn {
            padding: 3px 20px 5px;
        }
    }
}
</style>
